import { paramCase } from 'param-case'

function dashes(str: string) {
  return paramCase(str)
}

export function constructCssKey(...parts: Array<string | undefined>) {
  return parts.filter(Boolean).join('-')
}

export function defaultsToCss<T extends Record<string, unknown>>(
  defaults: T,
  prefix?: string,
) {
  return Object.entries(defaults).map(([key, value]) => {
    const cssKey = constructCssKey('-', prefix, dashes(key))

    return `${cssKey}: ${String(value)};`
  })
}

export function defaultsToVars<T extends Record<string, unknown>>(
  defaults: T,
  prefix?: string,
) {
  const objectKeys = Object.keys(defaults) as Array<keyof T>
  const vars: Partial<Record<keyof T, string>> = {}

  for (const key of objectKeys) {
    const cssKey = constructCssKey('-', prefix, dashes(String(key)))

    vars[key] = `var(${cssKey})`
  }

  // All keys should be defined now.
  return vars as Record<keyof T, string>
}
